import { Pipe, PipeTransform } from '@angular/core';

import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'usWholeNumber',
  standalone: true,
})
export class USWholeNumberPipe implements PipeTransform {
  private readonly decimalPipe = new DecimalPipe('en-US');

  transform(value: number | null | undefined): string {
    /* eslint-disable eqeqeq */
    if (value == null) {
      return '';
    }

    return this.decimalPipe.transform(value, '1.0-0') ?? '';
  }
}
